<template>
    <div>
        <div>
            <label class="main-text-color">{{ $t('layout.config.widgetTableContentFontSize') }}</label>
        </div>
        <el-input-number
            :max="optionConfigs.WidgetTableContentFontSize.max"
            :min="optionConfigs.WidgetTableContentFontSize.min"
            :step="optionConfigs.WidgetTableContentFontSize.step"
            size="small"
            v-model="model"
            placeholder="0"
        >
        </el-input-number>
    </div>
</template>

<script>
import { InputNumber } from 'element-ui'
import get from 'lodash/get'
import { optionConfigs } from '@/views/DashboardSettings/LayoutManagement/layout-management'
import { defaultFontSize } from '@/enum/defaultDashboardSettings'

export default {
    components: {
        [InputNumber.name]: InputNumber,
    },
    props: {
        value: {
            type: [ Number, String ],
            required: false
        }
    },
    computed: {
        optionConfigs() {
            return optionConfigs
        },
        hasOwnValue () {
            return this.value !== undefined
        },
        getTypeOfLayout () {
            return this.$store.getters['layout/getTypeOfLayout']
        },
        layoutConfig () {
            const widgetTableContentFontSize = get(this.$store.getters['layout/widgetTableContentFontSize'](this.getTypeOfLayout), 'fontSize')

            return widgetTableContentFontSize === '0px' ? defaultFontSize : widgetTableContentFontSize
        },
        stringValue () {
            if (this.hasOwnValue) {
                return this.value
            } else {
                return this.layoutConfig
            }
        },
        model: {
            get() {
                return this.stringValueToNumber(this.stringValue)
            },
            set (val) {
                this.$emit('input', this.numberValueToString(val))
            }
        }
    },
    methods: {
        stringValueToNumber (value) {
            return parseInt(value.replace('px', ''))
        },
        numberValueToString (value) {
            return `${value}px`
        }
    }
}
</script>
